import useI18n from "@I18n/hooks/useI18n";
import messages from "../Components/ConfirmationEmailTop/messages";
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";
import { resendEmailService } from "../services/resendEmail";
import { IToastProps } from "@modules/ServiceRequest/types";

export const useResendEmail = (showToast: IToastProps) => {
  const { formatMessage } = useI18n();

  const {
    mutate: resendEmail,
    isLoading,
    isSuccess,
    isError,
  } = useDataMutation((email: string) => resendEmailService(email), {
    onSuccess: () => {
      showToast({
        status: "success",
        description: formatMessage(
          messages["confirmationEmailTop.modal.emailHasBeenSent"]
        ),
      });
    },
    onError: () => {
      showToast({
        status: "error",
        description: formatMessage(
          messages["confirmationEmailTop.modal.errorWhileSendingAnEmail"]
        ),
      });
    },
  });

  return {
    resendEmail,
    isLoading,
    isSuccess,
    isError,
  };
};
